import Home from "./Home";
import Dashboard from "./Dashboard";
import NewSearchRecords from "./NewSearchRecords";

import DataQuality from "./DataQuality";
import Admin from "./Admin";
import Organizations from "./Admin/Organizations";
import SystemNotifications from "./Admin/SystemNotifications";
import AddEditOrganization from "./Admin/Organizations/AddEditOrganization";
import ViewOrganization from "./Admin/Organizations/ViewOrganization";
import ViewSystemNotification from "./Admin/SystemNotifications/ViewSystemNotification";
import AddEditSystemNotifications from "./Admin/SystemNotifications/AddEditSystemNotification";
import AddEditAccount from "./Admin/Organizations/ViewOrganization/AddEditAccount";
import ViewAccount from "./Admin/Organizations/ViewOrganization/ViewAccount";
import AddEditSource from "./Admin/Organizations/ViewOrganization/ViewAccount/AddEditSource";
import ViewElementTrust from "./Admin/Organizations/ViewOrganization/ViewAccount/ViewSource/ViewElementTrust";
import AddEditElementTrust from "./Admin/Organizations/ViewOrganization/ViewAccount/ViewSource/AddEditElementTrust";
import AddEditElementUseScore from "./Admin/Organizations/ViewOrganization/ViewAccount/ViewSource/ViewElementTrust/AddEditElementUseScore";
import ViewSource from "./Admin/Organizations/ViewOrganization/ViewAccount/ViewSource";
import AddEditSubscription from "./Admin/Organizations/ViewOrganization/ViewAccount/AddEditSubscription";
import ViewSubscription from "./Admin/Organizations/ViewOrganization/ViewAccount/ViewSubscription";
import Users from "./Admin/Users";
import ViewUser from "./Admin/Users/ViewUser";
import AddEditUser from "./Admin/Users/AddEditUser";
import ViewUserAccess from "./Admin/Users/ViewUser/ViewUserAccess";
import AddEditUserAccess from "./Admin/Users/ViewUser/AddEditUserAccess";
import ExternalVendors from "./Admin/ExternalVendors";
import ViewExternalVendor from "./Admin/ExternalVendors/ViewExternalVendor";
import AddEditExternalVendor from "./Admin/ExternalVendors/AddEditExternalVendor";
import DataStewardReport from "./Admin/DataStewardReport";
import Login from "./Login";
import LoginRedirect from "./LoginRedirect";
import SignOut from "./SignOut";
import NoAccess from "./NoAccess";
import NotFound from "./NotFound";
import EimpAssistant from "./EimpAssistant";
import { requiresAuth } from "../components/AuthProvider";
import Tasks from "./Tasks";
import ViewTask from "./Tasks/ViewTask";
import StartRerunTask from "./Tasks/StartRerunTask";
import ReviewQueueDashboard from "./ReviewQueue";
import ReviewQueueTable from "../routes/ReviewQueue/ReviewQueueTable";
import CompareRecords from "./NewSearchRecords/SearchRecordTable/CompareRecords/index";
import MockSurvivorship from "./NewSearchRecords/SearchRecordTable/MockSurvivorship/index";
import LinkageHistory from "./NewSearchRecords/SearchRecordTable/LinkageHistory/index";
import OverlayReviewQueue from "./ReviewQueue/OverlayReviewQueue";
import SearchRecordTable from "./NewSearchRecords/SearchRecordTable";
import QuarantineReviewQueue from "./ReviewQueue/QuarantineReviewQueue";
import Preview from "./Preview";

const globalAdminAccounts = ["Global Admin"];
const orgAdminAccounts = ["Organization Admin"];
const dataStewardAccounts = ["Data Steward"];
const adminAccounts = [...globalAdminAccounts, ...orgAdminAccounts];
const writeAccounts = [...adminAccounts, ...dataStewardAccounts];
const allAccounts = [...adminAccounts, ...dataStewardAccounts, "Read-Only"];
const allEnvironments = ["local", "dev", "stage", "nonprod", "prod"];
const lowerEnvironments = ["local", "dev", "stage"];

export default [
  {
    authorizedRoles: allAccounts,
    envAccess: allEnvironments,
    component: Home,
    label: "Home",
    path: "/",
    routes: [
      {
        authorizedRoles: allAccounts,
        envAccess: allEnvironments,
        component: requiresAuth(Dashboard),
        label: "Dashboard",
        path: "/dashboard"
      },
      {
        authorizedRoles: allAccounts,
        envAccess: allEnvironments,
        component: requiresAuth(NewSearchRecords),
        label: "Search Identities",
        path: "/search-identities-new",
        exact: false,
        isHidden: false,
        routes: [
          {
            authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(CompareRecords),
            label: "Compare Records",
            path: "/:clientId/view/:id/compare-records/:page",
            isHidden: true,
            exact: true
          },
          {
            authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(MockSurvivorship),
            label: "Mock Survivorship",
            path: "/:clientId/view/:id/mocksurvivorship",
            isHidden: true,
            exact: true
          },
          {
            authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(LinkageHistory),
            label: "Linkage History",
            path: "/:clientId/view/:goldenId/linkage-history",
            isHidden: true,
            exact: true
          }
        ]
      },
      {
        authorizedRoles: writeAccounts,
        envAccess: allEnvironments,
        component: requiresAuth(DataQuality, writeAccounts),
        label: "Data Quality",
        path: "/data-quality"
      },
      {
        authorizedRoles: globalAdminAccounts,
        envAccess: allEnvironments,
        component: requiresAuth(Tasks, globalAdminAccounts),
        label: "Tasks",
        path: "/tasks",
        routes: [
          {
            authorizedRoles: globalAdminAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(StartRerunTask, globalAdminAccounts),
            label: "Start Task",
            isHidden: true,
            path: "/start"
          },
          {
            authorizedRoles: globalAdminAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(ViewTask, globalAdminAccounts),
            label: "View Task",
            path: "/:taskId",
            isHidden: true,
            routes: [
              {
                authorizedRoles: globalAdminAccounts,
                envAccess: allEnvironments,
                component: requiresAuth(StartRerunTask, globalAdminAccounts),
                label: "Rerun Task",
                path: "/rerun"
              }
            ]
          }
        ]
      },
      {
        authorizedRoles: allAccounts,
        envAccess: allEnvironments,
        component: requiresAuth(ReviewQueueDashboard, allAccounts),
        allowedRoles: allAccounts,
        label: "Review Queue",
        path: "/review-queue-dashboard",
        isHidden: false,
        routes: [
          {
            authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(ReviewQueueTable),
            allowedRoles: allAccounts,
            path: "/:rqType",
            isHidden: true,
            routes: [
              {
                authorizedRoles: allAccounts,
                envAccess: allEnvironments,
                component: requiresAuth(CompareRecords),
                label: "Compare Records",
                path: "/compare-records/:page",
                isHidden: true,
                exact: true
              }
            ]
          },
          {
            authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(ReviewQueueTable),
            allowedRoles: allAccounts,
            path: "/:rqType/:assignedRQId",
            isHidden: true,
            routes: [
              {
                authorizedRoles: allAccounts,
                envAccess: allEnvironments,
                component: requiresAuth(CompareRecords),
                label: "Compare Records",
                path: "/compare-records/:page",
                isHidden: true,
                exact: true
              }
            ]
          }
        ]
      },
      {
        authorizedRoles: allAccounts,
        envAccess: allEnvironments,
        component: requiresAuth(OverlayReviewQueue, allAccounts),
        allowedRoles: allAccounts,
        label: "Record Overlay Review Queue",
        path: "/RecordOverlayReviewQueue/OverlayRecord",
        isHidden: true,
        routes: [
          {
            authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(SearchRecordTable),
            label: "Compare Records",
            path: "/:clientId/view/:ms_gid",
            isHidden: true,
            exact: true
          }
        ]
      },
      {
        authorizedRoles: allAccounts,
        envAccess: allEnvironments,
        component: requiresAuth(QuarantineReviewQueue, allAccounts),
        allowedRoles: allAccounts,
        label: "Record Quarantine Review Queue",
        path: "/RecordOverlayReviewQueue/QuarantineRecord",
        isHidden: true,
        routes: [
          {
            authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(SearchRecordTable),
            label: "Compare Records",
            path: "/:clientId/view/:ms_gid",
            isHidden: true,
            exact: true
          }
        ]
      },
      {
        authorizedRoles: adminAccounts,
        envAccess: allEnvironments,
        component: requiresAuth(Admin, adminAccounts),
        label: "Administration",
        path: "/admin",
        allowedRoles: adminAccounts,
        routes: [
          {
            authorizedRoles: adminAccounts,
            component: requiresAuth(Organizations, adminAccounts),
            label: "Organizations",
            path: "/organizations",
            routes: [
              {
                authorizedRoles: adminAccounts,
                component: requiresAuth(AddEditOrganization, adminAccounts),
                label: "Add Organization",
                path: "/add"
              },
              {
                authorizedRoles: adminAccounts,
                component: requiresAuth(ViewOrganization, adminAccounts),
                label: "View Organization",
                path: "/:id",
                routes: [
                  {
                    authorizedRoles: adminAccounts,
                    component: requiresAuth(AddEditOrganization, adminAccounts),
                    label: "Edit Organization",
                    path: "/edit"
                  },
                  {
                    authorizedRoles: adminAccounts,
                    component: requiresAuth(AddEditAccount, adminAccounts),
                    label: "Add Account",
                    path: "/accounts/add"
                  },
                  {
                    authorizedRoles: adminAccounts,
                    component: requiresAuth(ViewAccount, adminAccounts),
                    label: "View Account",
                    path: "/accounts/:clientId",
                    routes: [
                      {
                        authorizedRoles: adminAccounts,
                        component: requiresAuth(AddEditAccount, adminAccounts),
                        label: "Edit Account",
                        path: "/edit"
                      },
                      {
                        authorizedRoles: adminAccounts,
                        component: requiresAuth(AddEditSource, adminAccounts),
                        label: "Add Source",
                        path: "/sources/add"
                      },
                      {
                        authorizedRoles: adminAccounts,
                        component: requiresAuth(ViewSource, adminAccounts),
                        label: "View Source",
                        path: "/sources/:sourceId",
                        routes: [
                          {
                            authorizedRoles: adminAccounts,
                            component: requiresAuth(
                              AddEditSource,
                              adminAccounts
                            ),
                            label: "Edit Source",
                            path: "/edit"
                          },
                          {
                            authorizedRoles: adminAccounts,
                            component: requiresAuth(
                              AddEditElementTrust,
                              adminAccounts
                            ),
                            label: "Add Element Trust",
                            path: "/element_trust/add"
                          },
                          {
                            authorizedRoles: adminAccounts,
                            component: requiresAuth(
                              ViewElementTrust,
                              adminAccounts
                            ),
                            label: "View Element Trust",
                            path: "/element_trust/:elementTrustId",
                            routes: [
                              {
                                authorizedRoles: adminAccounts,
                                component: requiresAuth(
                                  AddEditElementTrust,
                                  adminAccounts
                                ),
                                label: "Edit Element Trust",
                                path: "/edit"
                              },
                              {
                                authorizedRoles: adminAccounts,
                                component: requiresAuth(
                                  AddEditElementUseScore,
                                  adminAccounts
                                ),
                                label: "Add Element Use",
                                path: "/element_use/add"
                              },
                              {
                                authorizedRoles: adminAccounts,
                                component: requiresAuth(
                                  AddEditElementUseScore,
                                  adminAccounts
                                ),
                                label: "Edit Element Use",
                                path:
                                  "/element_use/:elementUseTrustScoreId/edit"
                              }
                            ]
                          }
                        ]
                      },
                      // this functionality is not enabled!
                      // {
                      //   component: requiresAuth(AddEditSubscription, adminAccounts),
                      //   label: "Add Subscription",
                      //   path: "/subscriptions/add"
                      // },
                      {
                        authorizedRoles: adminAccounts,
                        component: requiresAuth(
                          ViewSubscription,
                          adminAccounts
                        ),
                        label: "View Subscription",
                        path: "/subscriptions/:subscriptionId",
                        routes: [
                          {
                            authorizedRoles: adminAccounts,
                            component: requiresAuth(
                              AddEditSubscription,
                              adminAccounts
                            ),
                            label: "Edit Subscription",
                            path: "/edit"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            authorizedRoles: adminAccounts,
            component: requiresAuth(Users, adminAccounts),
            label: "Users",
            path: "/users",
            routes: [
              {
                authorizedRoles: adminAccounts,
                component: requiresAuth(AddEditUser, adminAccounts),
                label: "Add User",
                path: "/add"
              },
              {
                authorizedRoles: adminAccounts,
                component: requiresAuth(ViewUser, adminAccounts),
                label: "View User",
                path: "/:id",
                routes: [
                  {
                    authorizedRoles: adminAccounts,
                    component: requiresAuth(AddEditUser, adminAccounts),
                    label: "Edit User",
                    path: "/edit"
                  },
                  {
                    authorizedRoles: adminAccounts,
                    component: requiresAuth(AddEditUserAccess, adminAccounts),
                    label: "Add User Access",
                    path: "/access/add"
                  },
                  {
                    authorizedRoles: adminAccounts,
                    component: requiresAuth(ViewUserAccess, adminAccounts),
                    label: "View User Access",
                    path: "/access/:accessId",
                    routes: [
                      {
                        authorizedRoles: adminAccounts,
                        component: requiresAuth(
                          AddEditUserAccess,
                          adminAccounts
                        ),
                        label: "Edit User Access",
                        path: "/edit"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            authorizedRoles: globalAdminAccounts,
            component: requiresAuth(SystemNotifications, globalAdminAccounts),
            label: "System Notifications",
            path: "/systemnotifications",
            routes: [
              {
                authorizedRoles: globalAdminAccounts,
                component: requiresAuth(
                  AddEditSystemNotifications,
                  globalAdminAccounts
                ),
                label: "Add System Notifications",
                path: "/add"
              },
              {
                authorizedRoles: globalAdminAccounts,
                component: requiresAuth(
                  ViewSystemNotification,
                  globalAdminAccounts
                ),
                label: "View System Notifications",
                path: "/:id",
                routes: [
                  {
                    authorizedRoles: globalAdminAccounts,
                    component: requiresAuth(
                      AddEditSystemNotifications,
                      globalAdminAccounts
                    ),
                    label: "Edit System Notifications",
                    path: "/edit"
                  }
                ]
              }
            ]
          },
          {
            authorizedRoles: adminAccounts,
            component: requiresAuth(DataStewardReport, adminAccounts),
            label: "User Actions Audit",
            path: "/user-actions-audit"
          },
          {
            authorizedRoles: adminAccounts,
            component: requiresAuth(ExternalVendors, adminAccounts),
            label: "External Vendors",
            path: "/externalvendors",
            routes: [
              {
                authorizedRoles: adminAccounts,
                component: requiresAuth(AddEditExternalVendor, adminAccounts),
                label: "Add Vendor",
                path: "/add"
              },
              {
                authorizedRoles: adminAccounts,
                component: requiresAuth(ViewExternalVendor, adminAccounts),
                label: "View Vendor",
                path: "/:id",
                routes: [
                  {
                    authorizedRoles: adminAccounts,
                    component: requiresAuth(
                      AddEditExternalVendor,
                      adminAccounts
                    ),
                    label: "Edit Vendor",
                    path: "/edit"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        authorizedRoles: allAccounts,
        envAccess: allEnvironments,
        component: SignOut,
        isHidden: true,
        label: "Sign Out",
        path: "/signout"
      },
      {
        authorizedRoles: allAccounts,
        envAccess: allEnvironments,
        component: NoAccess,
        isHidden: true,
        path: "/access-denied"
      },
      {
        authorizedRoles: allAccounts,
        envAccess: allEnvironments,
        component: NotFound,
        isHidden: true,
        path: "*"
      }
    ]
  },
  // { TODO: For future work
  //   authorizedRoles: allAccounts,
  //   envAccess: allEnvironments,
  //   component: EimpAssistant,
  //   path: "/eimp-assistant"
  // },
  {
    authorizedRoles: allAccounts,
    envAccess: allEnvironments,
    component: Login,
    path: "/login"
  },
  {
    authorizedRoles: allAccounts,
    envAccess: allEnvironments,
    component: LoginRedirect,
    path: "/oauth2/login-redirect"
  },
  {
    path: "/repartition-preview",
    component: CompareRecords,
    exact: true,
    label: "preview for repartition"
  },
  {
    authorizedRoles: allAccounts,
    envAccess: allEnvironments,
    component: requiresAuth(Preview),
    label: "Record Override Preview",
    path: "/override-preview"
  }
];
